import React, { Fragment, useEffect, useState } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import { FormGroup } from 'react-bootstrap';
import TimePicker from 'react-times';
import dateFormatReverse from 'constants/dateformatReverse';
import 'react-times/css/classic/default.css';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { DatePickerInput } from 'rc-datepicker';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';

const MeetingForm = ({
  handleValue,
  pocList,
  siteId,
  meetingById = null,
  noOfCamp,
  documentUploadUrl,
  documentUrlData,
}) => {
  const inputs = {
    utr_number: '',
    cheque_attachment: '',
    camp_type: '',
    camp_amount: 0,
    mom_send_status: 0,
    attendees: '',
    scheduled_date: '',
    scheduled_time: `${new Date().getHours()}:${new Date().getMinutes()}`,
    subject: '',
    body: '',
    type: '',
    status: 0,
  };
  const [formData, setData] = useState(inputs);
  const [pocsList, setPocsList] = useState([]);
  const [isFocus, setIsFocus] = useState(false);
  const [noOfCampLength, setNoOfCamp] = useState(0);

  useEffect(() => {
    if (noOfCamp) {
      setNoOfCamp(noOfCamp);
    } else setNoOfCamp(0);
  }, [noOfCamp]);

  useEffect(() => {
    setData({
      ...formData,
      camp_type: `${noOfCampLength > 1 ? `1` : `0`}`,
    });
  }, [noOfCampLength]);

  const handleDateHide = () => {
    if (formData.scheduled_date) {
      setIsFocus(true);
    }
  };

  useEffect(() => {
    if (meetingById !== null) {
      if (meetingById?.poc?.length > 0) {
        const pocIds =
          meetingById?.poc?.length > 0 && meetingById.poc.map((ele) => ele.id);
        setData({
          ...formData,
          poc: pocIds ? pocIds : '',
        });
        setPocsList(meetingById?.poc);
      }
      setData({
        ...formData,
        subject: meetingById?.meeting?.subject,
        body: meetingById?.meeting?.body,
        scheduled_date:
          (meetingById?.meeting?.scheduled_date &&
            dateFormatReverse(meetingById?.meeting?.scheduled_date)) ||
          new Date(),
      });
      setIsFocus(true);
    }
  }, [meetingById]);

  const handleDateChange = (date, dateString) => {
    setData({ ...formData, scheduled_date: dateString });
  };

  const handleMeetingData = () => {
    if (
      formData?.attendees?.length > 0 &&
      formData.scheduled_date !== '' &&
      formData.subject !== '' &&
      formData.body !== ''
    ) {
      meetingById !== null && meetingById?.meeting?.id
        ? handleValue({
            ...formData,
            site_id: siteId,
            id: meetingById?.meeting?.id,
          })
        : handleValue({ ...formData, site_id: siteId });
    } else handleValue(null);
  };
  useEffect(() => {
    handleMeetingData();
  }, [formData]);

  function onChange(value) {
    const { hour, minute } = value;
    setData({ ...formData, scheduled_time: `${hour}:${minute}` });
  }

  return (
    <FormSection title={localization.meetingDetails}>
      <DropDownInput
        multipule
        selectedList={pocsList.length > 0 ? pocsList : []}
        data={pocList}
        label={localization.toName}
        required
        errorMsg={localization.requiredName}
        getIdValue={(val) => {
          const list = val && val.length > 0 && val.map((ele) => ele.email);
          setData({
            ...formData,
            attendees: list,
          });
        }}
        isStarRequired={true}
      />
      <DropDownInput
        data={[
          { id: 1, name: 'mini' },
          { id: 2, name: 'full' },
        ]}
        label={localization.type}
        required
        errorMsg={localization.requiredName}
        getIdValue={(val) => {
          setData({
            ...formData,
            type: val.id,
          });
        }}
        isStarRequired={true}
      />

      <FormGroup
        className={`date custom_date_picker ${isFocus ? 'active-date' : ''}`}
      >
        <DatePickerInput
          value={formData.scheduled_date || new Date()}
          onChange={handleDateChange}
          onShow={() => setIsFocus(true)}
          onHide={handleDateHide}
          onClear={() => setIsFocus(false)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          required
          displayFormat="DD-MM-YYYY"
          returnFormat="YYYY-MM-DD"
          minDate={new Date()}
        />
        <label>
          {localization.selectDate}{' '}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        {!isFocus && (
          <label className="error date_error">{localization.isRequired}</label>
        )}
      </FormGroup>
      <FormGroup>
        <TimePicker
          theme="classic"
          timeFormat="HH:MM"
          timeMode={24}
          time={formData?.scheduled_time}
          onTimeChange={onChange}
        />
        <label>{localization.selectTime}</label>
        <label className="error date_error">{localization.isRequired}</label>
      </FormGroup>

      <ConstantInput
        value={formData.subject}
        label={localization.subject}
        errorMsg={localization.enterSubject}
        type="text"
        required
        handleChange={(value) => setData({ ...formData, subject: value })}
        isStarRequired={true}
        fullWidth
      />

      <TextAreaInput
        type="text"
        rows={4}
        className={`${!formData.body && 'empty'} inline-css scrollbar-styling`}
        label={localization.body}
        value={formData?.body}
        inputValue={formData?.body}
        errorMsg={localization.isRequired}
        handleChange={(e) => setData({ ...formData, body: e.target.value })}
      />

      <FormGroup style={{ display: 'none' }}>
        <div>
          <label>{localization.typeOfMeeting}</label>
        </div>
        {/* {[0, 1].map((item, index) => { */}
        {/* return ( */}
        <Fragment>
          <label htmlFor={localization.free}>{localization.free}</label>
          <Fragment>
            <input
              onChange={(e) =>
                setData({
                  ...formData,
                  camp_type: 0,
                })
              }
              type="radio"
              id={localization.free}
              checked={noOfCampLength < 2 ? true : false}
              name={localization.free}
              className="mx-1"
            />
          </Fragment>

          <Fragment>
            <label htmlFor={localization.paid}>{localization.paid}</label>
            <input
              onChange={() =>
                setData({
                  ...formData,
                  camp_type: 1,
                })
              }
              type="radio"
              id={localization.paid}
              checked={noOfCampLength >= 2 ? true : false}
              name={localization.paid}
              className="ml-1"
            />
          </Fragment>
        </Fragment>
        {/* ); */}
        {/* // })} */}
      </FormGroup>
      {noOfCampLength !== null && noOfCampLength > 1 && (
        <Fragment>
          <ConstantInput
            value={formData.camp_amount}
            label={localization.amount}
            regex={Regex.number.test(formData.camp_amount)}
            errorMsg={localization.isRequired}
            type="text"
            required={noOfCampLength > 2 && true}
            isStarRequired={noOfCampLength > 2 && true}
            handleChange={(value) =>
              setData({ ...formData, camp_amount: value })
            }
          />

          <ConstantInput
            value={formData.utr_number}
            label={localization.utrNumber}
            regex={Regex.alphaNumeric.test(formData.utr_number)}
            errorMsg={localization.isRequired}
            type="text"
            required={noOfCampLength > 2 && true}
            isStarRequired={noOfCampLength > 2 && true}
            handleChange={(value) =>
              setData({ ...formData, utr_number: value })
            }
          />
          <div className="form-group form-btn">
            <FileUpload
              id="addAttachment"
              accept=".pdf,.png,.jpg,.jpeg,.doc"
              documentUploadUrl={documentUploadUrl}
              documentUrlData={documentUrlData}
              onChange={(val) =>
                setData({ ...formData, cheque_attachment: val })
              }
            >
              <span className="btn btn-transparent">
                {localization.chequeAttachment}
              </span>
            </FileUpload>
          </div>
        </Fragment>
      )}
    </FormSection>
  );
};

MeetingForm.propTypes = {};

export default MeetingForm;
